import React from 'react';

import TableHeader from '../../../../components/Table/TableHeader';
import TablePagination from '../../../../components/Table/TablePagination';
import FormControl from '@material-ui/core/FormControl';
import InputSearch from '../../../../components/InputSearch';

const tabelaColunas = ['#ID', 'Tipo', 'Razão Social', 'Nome Fantasia', 'CNPJ', 'UF', 'Cidade', 'Status', '']

const ListCd = ({ subSellerPage, response, buscar, busca, mudarPagina }) => {

    const changePage = (page) => {
        mudarPagina(page)
    }

    const gotoDet = (idCdSeller) => {
        subSellerPage(idCdSeller)
    }

    return (
        <div>
            <div className="row justify-content-end">
                <div className='col-md-3'>
                    <FormControl>
                        <InputSearch
                            buscar={buscar}
                            buscaPor={busca}
                        />
                    </FormControl>
                </div>
            </div>
            <div className="row">
                <div className='col-12 mt20'>
                    <div className="table-responsive">
                        <table className="table">
                            <TableHeader columns={tabelaColunas} />

                            <tbody>
                                {
                                    (!response?.lista || response?.lista.length === 0) &&
                                    <tr><td colSpan="7"> Sem Registros </td></tr>
                                }
                                {
                                    response?.lista && response?.lista?.map((cd) => (
                                        <tr key={cd.id}>
                                            <td> {`00000${cd.codigo}`} </td>
                                            <td> {cd.tipo} </td>
                                            <td> {cd.razaoSocial} </td>
                                            <td> {cd.nomeFantasia} </td>
                                            <td> {cd.cnpj} </td>
                                            <td> {cd.uf} </td>
                                            <td> {cd.cidade} </td>
                                            <td> {cd.ativo ? 'Ativo' : 'Inativo'} </td>
                                            <td className="text-right">
                                                <i className="btn-edit-icon btn btn-icon fa fa-edit" onClick={() => gotoDet(cd.id)}></i>
                                            </td>
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </table>
                        <TablePagination data={response} changePage={changePage} />
                    </div>
                </div>
            </div>
        </div>
    );
}
export default ListCd;